import { useRouteMatch, Switch, Route, useHistory } from "react-router";
import OysHeadOfService from "./OysHeadOfService";
import { useSelector } from "react-redux";
import { LoadingPage } from "../LoadingPage";

const OysHeadOfServiceRoot = props => {
  let { path } = useRouteMatch();

  const oysPageData = useSelector(state => state.signupFlowData.signupPagesData?.["oys-head-of-service"]);
  const history = useHistory();

  const LoadingScreen = () => {
    return (
      <LoadingPage
        callback={() => history.replace("/contact-details")}
        heading={oysPageData?.loadingScreen.title ?? ""}
        text={oysPageData?.loadingScreen.body ?? ""}
      />
    );
  };

  return (
    <>
      <Switch>
        <Route path={`${path}`} component={OysHeadOfService} />
        <Route exact path={`${path}/loading`} component={LoadingScreen} />
      </Switch>
    </>
  );
};

export default OysHeadOfServiceRoot;
